'use client'
import { styled, SxProps } from '@mui/material'
import {
  DataGrid,
  GridColDef,
  GridColumnVisibilityModel,
  GridEventListener,
  GridRowParams,
  GridRowSelectionModel,
  GridToolbar,
  jaJP,
} from '@mui/x-data-grid'
import { GridInitialStateCommunity } from '@mui/x-data-grid/models/gridStateCommunity'
import { CSSProperties } from 'react'
interface Props {
  rows: []
  columns: GridColDef[]
  handleChange: (m: GridRowSelectionModel) => void
  onCellClick?: GridEventListener<'cellClick'>
  onColumnHeaderClick?: GridEventListener<'columnHeaderClick'>
  initialState?: GridInitialStateCommunity
  pageSizeOptions?:
    | readonly (
        | number
        | {
            value: number
            label: string
          }
      )[]
    | undefined
  checkboxSelection?: boolean
  rowSelectionModel?: GridRowSelectionModel
  columnVisibilityModel?: GridColumnVisibilityModel
  disableColumnFilter?: boolean
  isRowSelectable?: (params: GridRowParams) => boolean
  style?: CSSProperties
  sx?: SxProps
  hideFooter?: boolean
  showMenu?: boolean
}
const StyledDataGrid = styled(DataGrid)(() => ({
  border: 'none',
  padding: '8px',
  '& .MuiDataGrid-footerContainer': {
    minHeight: '30px',
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: '#f7f8f8',
    color: '#666',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 'bold',
  },
  '& .MuiDataGrid-virtualScroller': {
    overflow: 'hidden',
  },
}))

export default function KanseiDataGrid(props: Props) {
  const {
    rows,
    columns,
    checkboxSelection = true,
    handleChange,
    onCellClick,
    onColumnHeaderClick,
    initialState,
    pageSizeOptions = [100],
    columnVisibilityModel,
    isRowSelectable,
    rowSelectionModel,
    style,
    sx,
    hideFooter,
  } = props

  const slots = props.showMenu
    ? {
        toolbar: GridToolbar,
      }
    : {}

  return (
    <StyledDataGrid
      rows={rows}
      columns={columns}
      initialState={initialState}
      pageSizeOptions={pageSizeOptions}
      pagination
      checkboxSelection={checkboxSelection}
      rowSelectionModel={rowSelectionModel}
      rowHeight={40}
      columnHeaderHeight={40}
      isRowSelectable={isRowSelectable}
      onRowSelectionModelChange={(newSelectionModel) => {
        handleChange(newSelectionModel)
      }}
      onCellClick={onCellClick}
      onColumnHeaderClick={onColumnHeaderClick}
      slots={{ ...slots }}
      localeText={{
        ...jaJP.components.MuiDataGrid.defaultProps.localeText,
        noRowsLabel: '',
        columnsPanelTextFieldLabel: '件表示:',
        footerRowSelected: (count) => ` ${count}件が選択中`,
        footerTotalVisibleRows: (visibleCount, totalCount) =>
          `${visibleCount.toLocaleString()} 中 ${totalCount.toLocaleString()}`,
      }}
      columnVisibilityModel={columnVisibilityModel}
      disableColumnMenu={true}
      hideFooter={hideFooter}
      getRowHeight={() => 'auto'}
      sx={{ ...style, ...sx }}
    />
  )
}
